module.exports = __webpack_public_path__ + "img/infirmier-parcours-h.cdc70f82.jpg";